import React from "react";
import { Link } from 'react-router';
import { accountLinks } from "../../constants";
import logo from '../../../../assets/images/brand-icon-white.svg';

const MobileProfileMenu = ({ isShown, login, isAuthenticated,isMenuDisabled, logout, closeMenu }) => {
  const renderFirstName = () => {
    let firstName = '';
    if (login && login.login.party && login.login.party.first_name) {
      firstName = login.login.party.first_name;
    }
    return firstName;
  }

  return (
    isShown &&
      <div>
        <nav id="fullSidebarNav" className='sidenav open-nav mobile-menu-wrapper'>
          <img alt="logo" src={ logo } />
          <p style={{margin: '40px 0px 20px 0px', fontWeight: 600}}>
            Hello! {renderFirstName()}.
          </p>
          <ul className="mobile-list">
            { accountLinks.map((link, i) => (
              <li key={i} onClick={() => {closeMenu()}}><Link to={link.route} className={isMenuDisabled && link.route === '/cart' ? 'isDisabled' : ''}>{link.label}</Link></li>
            )) }
            <li onClick={() => {closeMenu()}}><Link to="/" onClick={logout}> Logout </Link></li>
          </ul>
        </nav>
        <div
          className="overlay-menu"
          data-do="hamburger"
          data-on="click"
          onClick={() => {
            closeMenu();
          }}
          style={{
            opacity: 1,
            zIndex: 999,
          }}>
        </div>
      </div>
  )
}

export default MobileProfileMenu;


/** WEBPACK FOOTER **
 ** ./src/components/Layout/Header/MobileHeader/MobileProfileMenu.js
 **/